










import { RadialStripe, Triangle } from '../lib'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class PreviewComponent extends Vue {
  @Prop() private preview!: RadialStripe
  generation = 0

  svgPoints(t: Triangle) {
    return t.points.map((p) => [p.x, p.y].join(',')).join(' ')
  }

  svgViewbox(t: Triangle) {
    return `0 0 ${this.preview.limitedWidth} ${this.preview.limitedHeight}`
  }

  svgStyle(t: Triangle) {
    const options: string[] = [`fill:${t.color.hex}`]

    const hp = this.preview.horizontalCenter * 100,
      vp = this.preview.verticalCenter * 100
    options.push(`transform-origin:${hp}% ${vp}%`)

    if (this.preview.anglePerSec != 0) {
      const duration = 360 / Math.abs(this.preview.anglePerSec),
        anim = this.preview.anglePerSec < 0 ? 'counterClockwise' : 'clockwise'
      options.push(`animation: ${anim} ${duration}s linear infinite`)
    }

    return options.join(';')
  }

  setMaxWidthHeight() {
    this.preview.maxWidth = window.innerWidth
    this.preview.maxHeight = (this.preview.maxWidth * this.preview.height) / this.preview.width
    this.generation++
  }

  mounted() {
    this.setMaxWidthHeight()
    window.addEventListener('resize', this.setMaxWidthHeight)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.setMaxWidthHeight)
  }
}
